import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { STAGE_META, STAGE_ORDER } from "./crmMeta";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CrmSettings({ token }) {
  const auth = { headers: { Authorization: `Bearer ${token}` } };
  const [probs, setProbs] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/settings/probabilities`, auth).then((r) => setProbs(r.data)).catch(() => {});
  }, []); // eslint-disable-line

  const save = async () => {
    try { const r = await axios.put(`${API}/admin/settings/probabilities`, { values: probs }, auth); setProbs(r.data); toast.success("Probabilities saved"); }
    catch { toast.error("Couldn't save probabilities."); }
  };

  if (!probs) return <div className="glass rounded-3xl p-16 text-center text-white/40">Loading settings…</div>;

  return (
    <div className="space-y-6 max-w-2xl" data-testid="crm-settings">
      <div className="glass rounded-3xl p-6">
        <p className="overline text-steel-light mb-1">Weighted Pipeline</p>
        <h2 className="font-serif text-2xl text-white mb-1" style={{ fontWeight: 500 }}>Stage Win Probabilities</h2>
        <p className="text-white/45 text-sm mb-6">Used to calculate the weighted forecast (ACV × probability) across open pipeline stages.</p>
        <div className="space-y-4">
          {STAGE_ORDER.map((k) => {
            const m = STAGE_META[k];
            return (
              <div key={k} className="flex items-center gap-4" data-testid={`prob-row-${k}`}>
                <div className="flex items-center gap-2 w-48 flex-shrink-0">
                  <span className="h-2.5 w-2.5 rounded-full" style={{ background: m.color }} />
                  <span className="text-white text-sm">{m.label}</span>
                </div>
                <input type="range" min="0" max="100" value={probs[k] ?? 0} onChange={(e) => setProbs({ ...probs, [k]: Number(e.target.value) })}
                  className="flex-1 accent-current" style={{ color: m.color }} data-testid={`prob-slider-${k}`} />
                <div className="flex items-center gap-1 w-20">
                  <input type="number" min="0" max="100" value={probs[k] ?? 0} onChange={(e) => setProbs({ ...probs, [k]: Math.max(0, Math.min(100, Number(e.target.value))) })}
                    data-testid={`prob-input-${k}`} className="w-14 bg-white/[0.03] border border-white/10 rounded-xl px-2 py-1.5 text-white text-sm text-center focus:outline-none focus:border-steel-light/60" />
                  <span className="text-white/40 text-sm">%</span>
                </div>
              </div>
            );
          })}
        </div>
        <button data-testid="save-probabilities" onClick={save} className="btn-pill bg-white text-ink-950 px-6 py-3 text-sm font-600 flex items-center gap-2 mt-6"><Save className="h-4 w-4" /> Save Probabilities</button>
      </div>
    </div>
  );
}
